export default {
  headers: [
    ['satellite-tracking/report.vehicle_name', 'vehicle'],
    ['satellite-tracking/report.driver_name', 'driver'],
    ['satellite-tracking/report.overspeed_time', 'overspeedTime']
  ]
}
